import { truthy } from '@/helpers/truthy'
import { isLTL, isParcel } from '@/helpers/determineShipmentType'

type ShippingDefinitionHolder = {
  Whiteglove: boolean | null | undefined
  Entryway: boolean | null | undefined
  Doorstep: boolean | null | undefined
}
export const isFurnitureVariant = <T extends ShippingDefinitionHolder>(variant: T) => (
  isLTL(
    truthy(variant?.Whiteglove),
    truthy(variant?.Entryway),
  )
)

export const isParcelVariant = <T extends ShippingDefinitionHolder>(variant: T) => (
  isParcel(
    truthy(variant?.Whiteglove),
    truthy(variant?.Entryway),
  )
)
